import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AdminProfileDataService } from 'src/app/admin-profile-data.service';
import { EncryptionService } from 'src/app/encryption.service';
import { VendorService } from 'src/app/services/vendor.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { ExamService } from '../exam.service';
import { CandidateService } from 'src/app/services/candidate.service';

@Component({
  selector: 'app-online-exam',
  templateUrl: './online-exam.component.html',
  styleUrl: './online-exam.component.scss'
})
export class OnlineExamComponent {
  @ViewChild('validationDialog') validationDialog!: TemplateRef<any>;
  @ViewChild('userValidationDialog') userValidationDialog!: TemplateRef<any>;
  exam_code!: string;
  exam_key!: string;
  examQuestions: any[] = [];
  examList: any[] = [];
  selectedExam: any = {}; // ✅ This must exist
  selectedAnswers: any = {};
  examStarted = false;
  examSubmitted = false;
  isTimeUp = false;
  timeLeft: number = 0;
  timerInterval: any;
  currentIndex: number = 0;
  currentPage: number = 0;
  totalMarks: number = 0;
  displayTime = '';
  questionsPerPage = 10;
  validationForm!: FormGroup;
  isValidated = false;
  candidateName!: string;
  scheduledDate!: string;
  scheduledTime!: string;
  interviewDuration!: string;
  avatarPath: string | null = null;
  attemptCount = 0;
  result: any;
  online_exam_key: string;
  vendorPasswordhide = true; // initially hide password
  showVerificationView = false;
  reviewData: any[] = [];
  result_unique_uuid: string;
  isExamStartAvailable = false;
  isExamExpired = false;
  examStatusText = '';
  examStartCheckInterval: any;
  userValidationForm: any;
  login_required!: boolean;
  constructor(
    private route: ActivatedRoute,
    private adminProfileDataService: AdminProfileDataService,
    private fb: FormBuilder, private dialog: MatDialog,
    private encryptionService: EncryptionService,
    private snackbarService: SnackBarService,
    private examService: ExamService,
    private vendorService: VendorService,
    private candidateService: CandidateService
  ) { }

  ngOnInit() {
    this.initUserLoginStatus();
    this.validationForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
    this.route.queryParams.subscribe(params => {
      this.exam_code = params['exam_code'];
      this.exam_key = params['exam_key'];

      if (this.exam_code && this.exam_key) {
        this.loadExamByCode();
        /* this.getCandidateQuestionPaperByExamCode();
        this.getAnonymousCandidateQuestionPaperByExamCode(); */
      }
    });
  }

  initUserLoginStatus() {
    this.userValidationForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      anonymous_name_status: [false]
    });
  }

  /** ✅ Get exam + questions from API **/
  getCandidateQuestionPaperByExamCode() {
    const reqObj = {
      exam_code: this.exam_code,
      exam_key: this.exam_key
    };

    this.adminProfileDataService.getCandidateQuestionPaperByExamCode(reqObj)
      .subscribe((res: any) => {
        if (res.statusCode === 200 && res.data) {
          this.selectedExam = res.data;           // ✅ Exam details
          this.examQuestions = res.data.questions || [];  // ✅ Questions list
          console.log('Exam Data:', this.selectedExam);
          // ✅ Convert Y/N → boolean
          this.login_required = res.data.login_required === 'Y';
        }
      });
  }


  /** ✅ Start Exam **/
  /*  startExam() {
     this.examStarted = true;
     this.examSubmitted = false;
     this.currentIndex = 0;
     this.timeLeft = this.selectedExam.duration * 60;
     this.startTimer();
   } */

  /** ✅ Timer **/
  startTimer() {
    clearInterval(this.timerInterval);

    this.isTimeUp = false;
    this.displayTime = this.formatTime(this.timeLeft);

    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.displayTime = this.formatTime(this.timeLeft);
      } else {
        clearInterval(this.timerInterval);
        this.isTimeUp = true;
        this.displayTime = 'Time Expired ⏰';
        // ✅ Auto submit exam when time is up
        //this.submitExam(true);
        this.handleSubmitExam(true)
      }
    }, 1000);
  }


  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs < 10 ? '0' + secs : secs}s`; // → Adds leading zero for better UX
  }


  /** ✅ Answer Selection **/
  submitAnswer(questionId: number, optionId: number, checked?: boolean) {
    const questionType = this.examQuestions.find(q => q.id === questionId)?.question_type;

    if (questionType === 'MULTIPLE') {
      if (!this.selectedAnswers[questionId]) this.selectedAnswers[questionId] = [];
      if (checked) {
        if (!this.selectedAnswers[questionId].includes(optionId))
          this.selectedAnswers[questionId].push(optionId);
      } else {
        const idx = this.selectedAnswers[questionId].indexOf(optionId);
        if (idx !== -1) this.selectedAnswers[questionId].splice(idx, 1);
      }
    } else {
      this.selectedAnswers[questionId] = optionId;
    }
  }



  /** ✅ Navigation for ONE_BY_ONE mode **/
  nextQuestion() {
    if (this.currentIndex < this.examQuestions.length - 1) {
      this.currentIndex++;
    }
  }

  prevQuestion() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  /** ✅ Pagination for ALL mode **/
  nextPage() {
    const totalPages = Math.ceil(this.examQuestions.length / this.questionsPerPage);
    if (this.currentPage < totalPages - 1) this.currentPage++;
  }

  prevPage() {
    if (this.currentPage > 0) this.currentPage--;
  }


  /** ✅ Format Timer **/
  get formattedTime() {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }

  openValidationDialog(): void {
    const dialogRef = this.dialog.open(this.validationDialog, {
      width: '650px',
      position: { top: '50px', }, // ✅ bottom-right corner
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      // Optional: handle dialog close result
    });
  }

  validateUserOnlineExam(dialogRef: any): void {
    const { email, password } = this.validationForm.value;

    // ✅ Build request object as required by API
    const reqObj = {
      email: email,
      exam_code: this.exam_code,
      online_exam_key: this.exam_key,
      p: this.encryptionService.encrypt256(password)
    };

    this.adminProfileDataService.validateUserOnlineExam(reqObj).subscribe({
      next: (resp: any) => {
        if (resp.statusCode === 200) {
          this.snackbarService.open(resp.supportMessage, 'close', 5000, 'center', 'top');
          this.isValidated = true;
          // ✅ Store details from API
          this.candidateName = resp.data.name;
          this.scheduledDate = resp.data.scheduled_date;
          this.scheduledTime = resp.data.scheduled_time;
          this.interviewDuration = resp.data.interview_duration;

          // ✅ Only store avatar if available
          this.avatarPath = (resp.data.media_name && resp.data.media_path !== 'TBD')
            ? `${resp.data.media_path}/${resp.data.media_name}`
            : null;

          // ✅ Save the UUID for later exam submission
          this.examService.setUUID(resp.data.uuid);

          dialogRef.close(true);
          this.startExamStatusCheck();
        }
      },

    });
  }
  retakeExam() {
    // ✅ Shuffle questions randomly
    this.examQuestions = this.shuffleArray([...this.selectedExam.questions]);

    // ✅ Clear previous answers
    this.selectedAnswers = {};

    // ✅ Reset exam flags
    this.examSubmitted = false;
    this.examStarted = false;
    this.isTimeUp = false;
    this.currentIndex = 0;
    this.currentPage = 0;

    // ✅ Restart timer
    this.timeLeft = this.selectedExam.duration * 60;
    this.startTimer();

    // ✅ Increment attempt count (optional, if you’re tracking it)
    this.attemptCount = (this.attemptCount || 0) + 1;

    console.log('🔁 Retake started. Attempt:', this.attemptCount);
  }



  submitExam(autoSubmit: boolean = false) {
    clearInterval(this.timerInterval);
    this.examStarted = false;
    this.examSubmitted = true;

    const reqObj = {
      exam_code: this.exam_code,
      key: this.exam_key,
      user_uuid: this.examService.getUUID(),
      result_unique_uuid: this.result_unique_uuid,
      type: autoSubmit ? 'T' : '',
      user_answers: Object.keys(this.selectedAnswers).map(qId => {
        const question = this.examQuestions.find(q => q.id === +qId);
        const answer = this.selectedAnswers[qId];

        if (!question) {
          return { q_id: +qId, user_answer: answer };
        }

        // ✅ MULTIPLE choice: already array of IDs
        if (question.question_type === 'MULTIPLE') {
          return { q_id: +qId, user_answer: answer };
        }

        // ✅ SINGLE / BOOLEAN choice:
        // If answer is an option text like "True" or "False",
        // map it to the corresponding option ID.
        const selectedOption = question.options.find(opt =>
          opt.id === answer ||
          opt.option_text.trim().toLowerCase() === String(answer).trim().toLowerCase()
        );

        return { q_id: +qId, user_answer: selectedOption ? selectedOption.id : answer };
      })
    };

    // 🛰️ Submit to API
    this.vendorService.submitExam(reqObj).subscribe({
      next: (resp: any) => {
        if (resp.statusCode === 200) {
          this.snackbarService.open(resp.supportMessage, 'close', 5000, 'center', 'top');

          const data = resp.data;

          // ✅ Map API response to component structure
          this.result = {
            totalMarks: data.exam_total_marks,
            obtainedMarks: data.user_total_obtained_marks,
            passMarks: data.exam_pass_marks,
            percentage: data.pass_percentage,
            isPass: data.status === 'P',
            attemptsLeft: data.retake_eligibility ? 1 : 0,// show retake only if eligible
            resultSuccess: data.result_success_msg,
            resultFail: data.result_fail_msg,
            show_total_marks: data.show_total_marks,
            show_pass_marks: data.show_pass_marks,
            show_percentage: data.show_percentage,
            show_results_status: data.show_results_status,
            check_result_status: data.check_result_status,
            show_result: data.show_result,
          };

          // ✅ store the answer review data
          this.reviewData = data.user_answers;
        }
      }
    });
  }
  shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }


  closeReview() {
    this.showVerificationView = false;
  }

  getInputType(q: any): string {
    const type = (q.q_type || q.question_type || q.type || '').trim().toUpperCase();

    if (type === 'MULTIPLE') return 'checkbox'; // ✅ only handle MULTIPLE
    return 'radio'; // SINGLE and BOOLEAN default
  }


  /* getInputType(q: any): string {
    const type = q.q_type || q.question_type || q.type || '';
    const normalized = type.trim().toUpperCase();
  
    if (['MULTIPLE', 'MULTI', 'MSQ'].includes(normalized)) return 'checkbox';
    if (['BOOLEAN', 'TRUE_FALSE'].includes(normalized)) return 'radio';
    return 'radio'; // default
  } */


  getAnswer(qId: number) {
    return this.reviewData.find((a: any) => a.q_id === qId);
  }

  isUserSelected(qId: number, optId: number): boolean {
    const ans = this.getAnswer(qId);
    if (!ans) return false;
    if (Array.isArray(ans.user_answer_id)) {
      return ans.user_answer_id.includes(optId);
    }
    return ans.user_answer_id === optId;
  }

  isCorrectOption(qId: number, optId: number): boolean {
    const ans = this.getAnswer(qId);
    return ans?.q_correct_answer_id === optId;
  }

  isWrongOption(qId: number, optId: number): boolean {
    const ans = this.getAnswer(qId);
    if (!ans) return false;
    return this.isUserSelected(qId, optId) && ans.q_correct_answer_id !== optId;
  }

  startExam() {
    const reqObj = {
      exam_code: this.exam_code,
      user_uuid: this.examService.getUUID(),
    };

    this.vendorService.startExam(reqObj).subscribe((resp: any) => {
      if (resp.statusCode === 200) {
        console.log('Exam started successfully:', resp);
        this.examStarted = true;
        this.examSubmitted = false;
        this.currentIndex = 0;
        this.timeLeft = this.selectedExam.duration * 60;
        // ✅ Save result_unique_uuid for later use
        this.result_unique_uuid = resp.data?.result_unique_uuid;
        this.startTimer();
      }
    },);
  }


  startExamStatusCheck() {
    function parseTime12to24(time12h: string): string {
      const [time, modifier] = time12h.split(' ');
      let [hours, minutes] = time.split(':').map(Number);
      if (modifier.toUpperCase() === 'PM' && hours < 12) hours += 12;
      if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }

    const time24 = parseTime12to24(this.scheduledTime);
    const examStartTime = new Date(`${this.scheduledDate}T${time24}`);

    // ✅ Convert string to number before math
    const durationInMinutes = Number(this.interviewDuration) || 0;
    const examEndTime = new Date(examStartTime.getTime() + durationInMinutes * 60 * 1000);

    this.examStartCheckInterval = setInterval(() => {
      const now = new Date();
      const diffToStart = examStartTime.getTime() - now.getTime();
      const diffToEnd = examEndTime.getTime() - now.getTime();

      if (diffToStart > 30 * 60 * 1000) {
        this.examStatusText = 'Exam Yet to start';
        this.isExamStartAvailable = false;
        this.isExamExpired = false;
      } else if (diffToStart > 0 && diffToStart <= 30 * 60 * 1000) {
        const hrs = Math.floor(diffToStart / (1000 * 60 * 60));
        const mins = Math.floor((diffToStart % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((diffToStart % (1000 * 60)) / 1000);
        this.examStatusText = `Exam will start   ${hrs}h  ${mins}m  ${secs}s`;
        this.isExamStartAvailable = false;
        this.isExamExpired = false;
      } else if (diffToStart <= 0 && diffToEnd > 0) {
        //this.examStatusText = 'Exam time started';
        this.isExamStartAvailable = true;
        this.isExamExpired = false;
      } else if (diffToEnd <= 0) {
        //this.examStatusText = 'Exam time expired';
        this.isExamStartAvailable = false;
        this.isExamExpired = true;
        clearInterval(this.examStartCheckInterval);
      }
    }, 1000);
  }

  handleLogin() {
    this.dialog.open(this.userValidationDialog, {
      width: '700px',
      //disableClose: true
    });
  }
  submitValidation(dialogRef: any) {
    if (this.userValidationForm.invalid) return;

    const formValue = this.userValidationForm.value;

    const reqObj = {
      name: formValue.name,
      email: formValue.email,
      mobile: formValue.mobile,
      anonymous_name_status: formValue.anonymous_name_status ? 'Y' : 'N',
      exam_code: this.exam_code,
      online_exam_key: this.exam_key,
    };

    this.vendorService.createAnonymousUser(reqObj).subscribe((resp: any) => {
      if (resp.statusCode === 200) {
        // ✅ THIS IS MISSING
        this.isValidated = true;

        // ✅ Exam date, time and duration
        // Correct mapping from API response
        this.candidateName = resp.data.name;
        this.scheduledDate = resp.data.interview_date;
        this.scheduledTime = resp.data.start_time;
        this.interviewDuration = resp.data.interview_duration;



        // ✅ STORE UUID FOR START EXAM API
        this.examService.setUUID(resp.data.uuid);
         dialogRef.close(true);
          this.startExamStatusCheck();

        dialogRef.close(resp);
        this.snackbarService.open(resp.supportMessage, 'close', 5000, 'center', 'top');
      }
    },);

  }

  getAnonymousCandidateQuestionPaperByExamCode() {
    const reqObj = {
      exam_code: this.exam_code,
      exam_key: this.exam_key
    };

    this.candidateService.getAnonymousCandidateQuestionPaperByExamCode(reqObj)
      .subscribe((res: any) => {
        if (res.statusCode === 200 && res.data) {
          this.selectedExam = res.data;           // ✅ Exam details
          this.examQuestions = res.data.questions || [];  // ✅ Questions list
          console.log('Exam Data:', this.selectedExam);
          // ✅ Convert Y/N → boolean
          this.login_required = res.data.login_required === 'Y';
        }
      });
  }
  loadExamByCode(): void {
    if (!this.exam_code || this.exam_code.length < 3) {
      this.showInvalidExamCode();
      return;
    }

    const thirdChar = this.exam_code.charAt(2).toUpperCase();

    switch (thirdChar) {
      case 'A':
        this.getAnonymousCandidateQuestionPaperByExamCode();
        break;

      case 'C':
        this.getCandidateQuestionPaperByExamCode();
        break;

      default:
        this.showInvalidExamCode();
        break;
    }
  }
  showInvalidExamCode(): void {
    this.examQuestions = [];
    this.selectedExam = {};
    this.login_required = false;

    /* this.snackbarService.open(
      'Invalid exam code',
      'close',
      4000,
      'center',
      'top'
    ); */
  }
  startExamAnonymous() {
    const reqObj = {
      exam_code: this.exam_code,
      user_uuid: this.examService.getUUID(),
    };

    this.vendorService.startExamAnonymous(reqObj).subscribe((resp: any) => {
      if (resp.statusCode === 200) {
        console.log('Exam started successfully:', resp);
        this.examStarted = true;
        this.examSubmitted = false;
        this.currentIndex = 0;
        this.timeLeft = this.selectedExam.duration * 60;
        // ✅ Save result_unique_uuid for later use
        this.result_unique_uuid = resp.data?.result_unique_uuid;
        this.startTimer();
      }
    },);
  }

  handleButtonClick() {
    if (!this.isValidated) {
      this.openValidationDialog();
    }
  }

  handleStartExam() {
    if (this.login_required) {
      this.startExamAnonymous();         // logged-in
    } else {
      this.startExam();
      // anonymous
    }
  }


  /* handleButtonClick(): void {
      if (!this.isValidated) {
        // Open validation popup first
        this.openValidationDialog();
      } else {
        // Once validated, start the exam
        this.startExam();
        this.startExamAnonymous();
      }
    } */
  submitExamAnonymous(autoSubmit: boolean = false) {
    clearInterval(this.timerInterval);
    this.examStarted = false;
    this.examSubmitted = true;

    const reqObj = {
      exam_code: this.exam_code,
      key: this.exam_key,
      user_uuid: this.examService.getUUID(),
      result_unique_uuid: this.result_unique_uuid,
      type: autoSubmit ? 'T' : '',
      user_answers: Object.keys(this.selectedAnswers).map(qId => {
        const question = this.examQuestions.find(q => q.id === +qId);
        const answer = this.selectedAnswers[qId];

        if (!question) {
          return { q_id: +qId, user_answer: answer };
        }

        // ✅ MULTIPLE choice: already array of IDs
        if (question.question_type === 'MULTIPLE') {
          return { q_id: +qId, user_answer: answer };
        }

        // ✅ SINGLE / BOOLEAN choice:
        // If answer is an option text like "True" or "False",
        // map it to the corresponding option ID.
        const selectedOption = question.options.find(opt =>
          opt.id === answer ||
          opt.option_text.trim().toLowerCase() === String(answer).trim().toLowerCase()
        );

        return { q_id: +qId, user_answer: selectedOption ? selectedOption.id : answer };
      })
    };

    // 🛰️ Submit to API
    this.vendorService.submitExamAnonymous(reqObj).subscribe({
      next: (resp: any) => {
        if (resp.statusCode === 200) {
          this.snackbarService.open(resp.supportMessage, 'close', 5000, 'center', 'top');

          const data = resp.data;

          // ✅ Map API response to component structure
          this.result = {
            totalMarks: data.exam_total_marks,
            obtainedMarks: data.user_total_obtained_marks,
            passMarks: data.exam_pass_marks,
            percentage: data.pass_percentage,
            isPass: data.status === 'P',
            attemptsLeft: data.retake_eligibility ? 1 : 0,// show retake only if eligible
            resultSuccess: data.result_success_msg,
            resultFail: data.result_fail_msg,
            show_total_marks: data.show_total_marks,
            show_pass_marks: data.show_pass_marks,
            show_percentage: data.show_percentage,
            show_results_status: data.show_results_status,
            check_result_status: data.check_result_status,
            show_result: data.show_result,
          };

          // ✅ store the answer review data
          this.reviewData = data.user_answers;
        }
      }
    });
  }
  handleSubmitExam(autoSubmit: boolean = false) {
    if (this.login_required) {
      // 🔐 logged-in user
      this.submitExamAnonymous(autoSubmit);
    } else {
      this.submitExam(autoSubmit);
      // 👤 anonymous user

    }
  }
decodeHtml(encodedText: string): string {
  if (!encodedText) return '';

  const txt = document.createElement('textarea');
  txt.innerHTML = encodedText;

  return txt.value
    .replace(/<\/p>/gi, '\n\n')   // paragraph spacing
    .replace(/<br\s*\/?>/gi, '\n') // line breaks
    .replace(/<[^>]*>?/gm, '')     // remove remaining tags
    .replace(/\u00A0/g, ' ')       // replace &nbsp;
    .trim();
}

}